import { useEffect, useMemo, useState } from "react";
import { ISummaryCardPros, SummaryCardVariant } from "./types";
import { ChartData } from "../../../components/chart/types";
import { formatDate } from "../../../utils/date.utils";
import { formatAmountToString } from "./utils";
import { SummaryCardVariantsThemeMap } from "./constants";

export const useSummaryCardController = ({
  summaries,
  date,
  unit,
  variant = SummaryCardVariant.primary
}: ISummaryCardPros) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [chartData, setChartData] = useState<ChartData[]>([]);

  useEffect(() => {
    const total = summaries.reduce((acc, item) => acc + item.amount, 0);
    setTotalAmount(total);

    const chartData = [];
    for (const summary of summaries) {
      const percent = (summary.amount * 100) / total;
      chartData.push({
        color: summary.chartColor,
        value: percent
      });
    }

    setChartData(chartData);
  }, [unit, summaries]);

  const totalAmountStr = useMemo(() => {
    return formatAmountToString(totalAmount, unit);
  }, [totalAmount, unit]);

  const dateStr = useMemo(() => {
    return formatDate(date);
  }, [date]);

  const theme = SummaryCardVariantsThemeMap[variant];
  return { totalAmount, chartData, dateStr, totalAmountStr, theme };
};
